// *https://www.registers.service.gov.uk/registers/country/use-the-api*
// import fetch from "cross-fetch";
import akmApi from "../../../../../../apis/akmApi";
import { CONFIG_AKM } from "../../../../../../config/ConfigAkm";
import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import { ThemeConsumer } from "react-bootstrap/esm/ThemeProvider";

function sleep(delay = 0) {
    return new Promise((resolve) => {
        setTimeout(resolve, delay);
    });
}

export default function AutocompleteSearchDinas(props) {
    const [open, setOpen] = React.useState(false);
    const [search, setSearch] = React.useState(null);
    const [options, setOptions] = React.useState([]);
    const loading = open && options.length === 0;

    React.useEffect(() => {
        if (search !== null) {
            (async () => {
                setOpen(true);
                await akmApi
                    .get(CONFIG_AKM.DINAS_GET_BY_LIKE_NAME + search)
                    .then((data) => {
                        console.info("data", data.data.data);
                        const listDinas = data.data.data;
                        if (listDinas.length > 0) {
                            setOptions(data.data.data);
                        } else {
                            setOptions([]);
                        }
                    })
                    .catch(function (error) {
                        console.error("Error Response Fetch Dinas", error);
                    });
            })();
        }
        return () => {
            setSearch(null);
        };
    });

    return (
        <Autocomplete
            size="small"
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            getOptionSelected={(option, value) => option.namaDinas === value.namaDinas}
            getOptionLabel={(option) => option.namaDinas}
            options={options}
            loading={loading}
            disableClearable={true}
            onChange={(event, value) => {
                console.info("value", value.idDinasPemda);
                props.handleChangeDinas(value.idDinasPemda);
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Cari Dinas"
                    variant="outlined"
                    onChange={(event) => {
                        setSearch(event.target.value);
                    }}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
        />
    );
}
